import { useQuery } from "@tanstack/react-query"

import type { FlowPromptResponse } from "@/api/models"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

export function useGetFlowPrompts() {
  return useQuery({
    queryKey: queryKeys.flowPrompts,
    queryFn: async () => {
      const response = await api.get<FlowPromptResponse>("/explorer/flow-prompts")
      return response as unknown as FlowPromptResponse
    },
    staleTime: 30_000, // Cache for 30 seconds before considering stale
  })
}
